import { Button } from "@/components/ui/button";
import { Calendar, User, Clock, HandHeart } from "lucide-react";

const STATUS_STYLES = {
  "Abierta": "bg-[#EAF2EE] text-[#2C5545] border-[#2C5545]/30",
  "Ayuda Coordinada": "bg-[#FEF3C7] text-[#92400E] border-[#D97706]/30",
  "Completada": "bg-[#F3F1EF] text-[#4A4646] border-[#D1C9C1]",
};

const formatDate = (iso) => {
  if (!iso) return "";
  try {
    const d = new Date(iso);
    return d.toLocaleDateString("es-ES", { day: "numeric", month: "long", year: "numeric" });
  } catch {
    return iso;
  }
};

export default function NeedCard({ need, onHelp }) {
  const statusClass = STATUS_STYLES[need.status] || STATUS_STYLES["Abierta"];
  const disabled = need.status === "Completada";

  return (
    <article
      data-testid={`need-card-${need.id}`}
      className="bg-white rounded-2xl border-2 border-[#D1C9C1] p-6 sm:p-7 shadow-sm hover:shadow-md transition-shadow"
    >
      <div className="flex flex-wrap items-center gap-2 mb-3">
        <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wide bg-[#8A3A33]/10 text-[#8A3A33] border border-[#8A3A33]/20">
          {need.category}
        </span>
        <span className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wide border ${statusClass}`}>
          {need.status}
        </span>
      </div>

      <h3 className="font-serif text-2xl font-bold text-[#1A1818] leading-snug mb-2">
        {need.title}
      </h3>
      <p className="text-base sm:text-lg text-[#4A4646] leading-relaxed mb-5 whitespace-pre-wrap">
        {need.description}
      </p>

      <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 text-sm text-[#4A4646] mb-5">
        <div className="flex items-center gap-2">
          <User className="w-4 h-4 text-[#8A3A33]" />
          <span className="font-medium">{need.name}</span>
        </div>
        <div className="flex items-center gap-2">
          <Clock className="w-4 h-4 text-[#8A3A33]" />
          <span>Publicado: {formatDate(need.created_at)}</span>
        </div>
        <div className="flex items-center gap-2">
          <Calendar className="w-4 h-4 text-[#8A3A33]" />
          <span>Se necesita: {formatDate(need.needed_date)}</span>
        </div>
      </div>

      {!disabled && (
        <Button
          data-testid={`help-btn-${need.id}`}
          onClick={() => onHelp(need)}
          className="w-full sm:w-auto h-14 px-6 text-lg font-semibold bg-[#2C5545] hover:bg-[#1F3D32] text-white rounded-lg"
        >
          <HandHeart className="w-5 h-5 mr-2" />
          Yo Puedo Ayudar
        </Button>
      )}

      {need.volunteers && need.volunteers.length > 0 && (
        <p className="mt-4 text-sm text-[#2C5545] font-medium">
          {need.volunteers.length} {need.volunteers.length === 1 ? "persona se ha ofrecido" : "personas se han ofrecido"} a ayudar
        </p>
      )}
    </article>
  );
}
